import { Search, X } from "lucide-react";
import { forwardRef, type ComponentPropsWithoutRef } from "react";

import { cn } from "@/shared/lib/utils";

import { Input } from "../primitives/input";

type ColocaSearchInputProps = Omit<ComponentPropsWithoutRef<"input">, "type" | "value" | "onChange"> & {
  value: string;
  onValueChange: (value: string) => void;
  clearable?: boolean;
  iconClassName?: string;
};

// Standalone (not RHF-bound) — use `ColocaInputField` for form-bound text.
export const ColocaSearchInput = forwardRef<HTMLInputElement, ColocaSearchInputProps>(
  function ColocaSearchInput(
    { value, onValueChange, placeholder, className, clearable = true, iconClassName, ...rest },
    ref,
  ) {
    return (
      <div className={cn("relative w-full", className)}>
        <Search
          aria-hidden="true"
          className={cn(
            "pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground",
            iconClassName,
          )}
        />
        <Input
          ref={ref}
          type="text"
          value={value}
          placeholder={placeholder}
          onChange={(event) => onValueChange(event.target.value)}
          className="pl-8 pr-8"
          {...rest}
        />
        {clearable && value.length > 0 && (
          <button
            type="button"
            onClick={() => onValueChange("")}
            aria-label="Clear search"
            className="absolute right-2 top-1/2 -translate-y-1/2 rounded p-0.5 text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
    );
  },
);
